import { render } from "./EventPreview.vue?vue&type=template&id=623ad1b3&scoped=true"
import script from "./EventPreview.vue?vue&type=script&lang=js"
export * from "./EventPreview.vue?vue&type=script&lang=js"

import "./EventPreview.vue?vue&type=style&index=0&id=623ad1b3&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623ad1b3"]])

export default __exports__